var map = {
	"./ban-logo.png": "dabd",
	"./banano-banner.png": "428fa",
	"./banano-logo-big.png": "3bb2",
	"./bsc-logo.svg": "bab2",
	"./fantom-logo.svg": "5287",
	"./kalium-appstore.svg": "d9bc2",
	"./kalium-playstore.svg": "92c7",
	"./polygon-logo.svg": "cffe",
	"./wban-logo-arbitrum.svg": "dcd3",
	"./wban-logo-bsc.svg": "7a70",
	"./wban-logo-ethereum.svg": "0ee65",
	"./wban-logo-fantom.svg": "619f",
	"./wban-logo-polygon.svg": "92a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";